import React, { useEffect, useState } from 'react'
import { Button, Spinner } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

function AddPenalityModal({dispatchPenality, showAddPenalityModal, setShowAddPenalityModal, addPenalityModalDetails}) {
    console.log("firsaddPenalityModalDetailst",addPenalityModalDetails)
    const [term,setTerm] = useState('')
    const [penalityAmount, setPenalityAmount] = useState('')

    const onchangeTerm = (e) => {
        setTerm(e.target.value)
    }

    const onClickAdd = () => {
        if(term === ""){
            return alert("Please select the Term")
        }else if(penalityAmount === ''){
            return alert("Please enter penality amount")
        }
        dispatchPenality({penalityAmount,term,branch:addPenalityModalDetails.branch,academicYear:addPenalityModalDetails.selectedAcademicYear})
        setShowAddPenalityModal(false)
    }   

  return (
            <Modal size="md" show={showAddPenalityModal} onHide={() => { setShowAddPenalityModal(!showAddPenalityModal) }}  scrollable>
            <Modal.Header closeButton>
                <Modal.Title> <p style={{padding:0, margin:0, color:"#333333", fontFamily:["Helvetica", "sans-serif"], fontSize:"20px"}}>Select Term</p></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <label className="control-label" htmlFor="bankBranch">Select The Term</label>
                    <select style={{ backgroundImage: 'none' }} value={term} placeholder="Select the Term" onChange={onchangeTerm} className="form-control mb-3" aria-label="Default select example">
                        <option disabled selected hidden value="" >Select The Term</option>
                        {addPenalityModalDetails?.termFees?.map((each,i) => {
                            return <option key={i} value={each}>{each}</option>
                        })}
                    </select>                    
                </div>
                <div className="form-group">
                    <label className="control-label" htmlFor="bankBranch">Enter Penality Amount</label>
                    <input autoComplete='off' type="number" placeholder='Enter amount' value={penalityAmount} onChange={(e) => {setPenalityAmount(e.target.value)}} className="form-control" id="penality" name="penality" required />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => { setShowAddPenalityModal(false) }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {onClickAdd()}}>
                    Add
                </Button>
            </Modal.Footer>
        </Modal>
  )
}

export default AddPenalityModal